import { get, post, del, put, patch, ApiError, isCancelError } from "aws-amplify/api";

export const initializeAPIOptions = (token, body, queryParams, additionalHeaders) => {
    const options = { headers: { Authorization: token, ...additionalHeaders } };
    if (body) {
        options.body = body;
    }
    if (queryParams) {
        options.queryParams = queryParams;
    }
    return options;
};

export const putAPI = (apiName, path, options, abortSignal) => {
    return request(put({ apiName, path, options }), abortSignal);
};

export const patchAPI = (apiName, path, options, abortSignal) => {
    return request(patch({ apiName, path, options }), abortSignal);
};

export const getAPI = (apiName, path, options, abortSignal, requestOptions) => {
    return request(get({ apiName, path, options }), abortSignal, requestOptions);
};

export const postAPI = (apiName, path, options, abortSignal, requestOptions) => {
    return request(post({ apiName, path, options }), abortSignal, requestOptions);
};

export const deleteAPI = (apiName, path, options, abortSignal) => {
    return request(del({ apiName, path, options }), abortSignal);
};

/**
 * Makes error handling in components easier
 * @throws simplified error
 */
function simplifyError(error) {
    let simplifiedError = error;
    if (isCancelError(error)) {
        simplifiedError = { type: "canceled", message: error.message, original: error };
    } else if (error instanceof ApiError && error.response) {
        const { body } = error.response;

        let parsedBody = body;
        try {
            parsedBody = JSON.parse(body);
        } catch {
            // body is not JSON, leave it as a string
        }
        simplifiedError = {
            type: "api",
            message:
                parsedBody?.error?.message ||
                parsedBody?.error.toString() ||
                parsedBody?.toString(),
            errorBody: parsedBody,
            original: error,
        };
    }
    throw simplifiedError;
}

const request = async (operation, abortSignal, options) => {
    const abortRequest = () => {
        operation.cancel(abortSignal?.reason);
    };

    if (abortSignal) {
        if (abortSignal.aborted) {
            abortRequest();
        } else {
            abortSignal.addEventListener("abort", abortRequest, { once: true });
        }
    }

    try {
        const result = await operation.response;
        if (options?.raw) {
            return result?.body;
        } else {
            const response = await result?.body.json();
            return response;
        }
    } catch (error) {
        if (!isCancelError(error)) {
            console.error(error);
        }
        simplifyError(error);
    } finally {
        abortSignal?.removeEventListener("abort", abortRequest);
    }
};
